<template>
    <div id="quiz">
      <transition name="screen-fade" mode="out-in">

      <HomeView
        v-if="screen === 'home'"
        key="home"
        @start-quiz="onStartQuiz"
      />

      <QuizView
        v-else-if="screen === 'quiz'"
        key="quiz"
        :cat-key="activeCat.key"
        :cat-name="activeCat.name"
        :cat-emoji="activeCat.emoji"
        @back="screen = 'home'"
        @finish="onFinish"
      />

      <ResultView
        v-else-if="screen === 'result'"
        key="result"
        :result="lastResult"
        @retry="onRetry"
        @home="goHome"
      />

      <LeaderboardView
        v-else-if="screen === 'leaderboard'"
        key="leaderboard"
        :user-name="userName"
      />

      <ProfileView
        v-else-if="screen === 'profile'"
        key="profile"
        :user-name="userName"
      />

    </transition>

    <!-- BOTTOM NAV (hidden during quiz/result) -->
    <nav v-if="showNav" class="nav">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        class="nav-item"
        :class="{ active: activeTab === tab.id }"
        @click="switchTab(tab.id)"
      >
        <span class="nav-icon" v-html="tab.icon"></span>
        {{ tab.label }}
        <div class="nav-dot"></div>
      </button>
    </nav>
    </div>
</template>
<script setup>
import '@/style.css'
</script>
<script>
import HomeView from '@/components/quizComponents/HomeView.vue';
import QuizView from '@/components/quizComponents/QuizView.vue';
import ResultView from '@/components/quizComponents/ResultView.vue';
import LeaderboardView from '@/components/quizComponents/LeaderboardView.vue';
import ProfileView from '@/components/quizComponents/ProfileView.vue';
import { store } from 'vuex';
import { CATEGORIES } from '@/data/questions';

const TAB_ICONS = {
  home: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>`,
  leaderboard: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>`,
  profile: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>`,
}

export default {
    components: { HomeView, QuizView, ResultView, LeaderboardView, ProfileView },

    data() {
        return {
        screen: 'home',
        activeTab: 'home',
        activeCat: null,
        lastResult: null,
        store,
        tabs: [
            { id: 'home',        label: 'Bosh sahifa', icon: TAB_ICONS.home },
            { id: 'leaderboard', label: 'Reyting',     icon: TAB_ICONS.leaderboard },
            { id: 'profile',     label: 'Profil',       icon: TAB_ICONS.profile },
        ],
        }
    },

    computed: {
        showNav() {
        return !['quiz', 'result'].includes(this.screen)
        },

        userName() {
        return window.Telegram?.WebApp?.initDataUnsafe?.user?.first_name || 'Foydalanuvchi'
        },
    },

    methods: {
        switchTab(id) {
        this.activeTab = id
        this.screen = id
        },

        onStartQuiz(catKey) {
        this.activeCat = CATEGORIES.find(c => c.key === catKey)
        this.screen = 'quiz'
        },

        onFinish(result) {
        // save to store
        this.$store.dispatch('addResult', result)
        this.lastResult = result
        this.screen = 'result'
        },

        onRetry() {
        this.screen = 'quiz'
        },

        goHome() {
        this.activeTab = 'home'
        this.screen = 'home'
        },
    },

    mounted() {
        const tg = window.Telegram?.WebApp
        if (tg) {
        tg.expand()
        tg.setHeaderColor?.('#0a0a12')
        tg.setBackgroundColor?.('#0a0a12')
        }
    },
}
</script>

<style scoped>
  
/* ─── NAV ───────────────────────────────────────────────── */
.nav {
  position: fixed; bottom: 0; left: 0; right: 0;
  background: var(--quiz-bg);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid var(--quiz-border);
  display: flex;
  padding: 10px 0 calc(10px + env(safe-area-inset-bottom, 0px));
  z-index: 100;
}
.nav-item {
  flex: 1;
  display: flex; flex-direction: column;
  align-items: center; gap: 4px;
  cursor: pointer;
  padding: 6px;
  border: none; background: none;
  color: var(--quiz-text3);
  font-family: 'Nunito', sans-serif;
  font-size: 10px; font-weight: 600;
  letter-spacing: 0.04em;
  transition: color 0.2s;
  position: relative;
}
.nav-icon { width: 22px; height: 22px; display: flex; }
.nav-icon svg { width: 22px; height: 22px; transition: transform 0.2s; }
.nav-item.active { color: var(--quiz-primary); }
.nav-item.active .nav-icon svg { transform: scale(1.15); }
.nav-dot {
  width: 4px; height: 4px; border-radius: 50%;
  background: var(--quiz-primary);
  opacity: 0; transition: opacity 0.2s;
}
.nav-item.active .nav-dot { opacity: 1; }

</style>